import { UserInformation } from "@/api/signin";
import { userKeys } from "@/features/auth/keys";
import { useVerifyEmail } from "@/features/email-verification/useVerifyEmail";
import { useQueryClient } from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";
import { useEffect } from "react";
import EmailVerificationFailed from "./_components/EmailVerificationFailed";
import EmailVerified from "./_components/EmailVerified";
import EmailVerifying from "./_components/EmailVerifying";

export default function EmailVerificationPage() {
	const verifyEmailMutation = useVerifyEmail();
	const queryClient = useQueryClient();
	const { token } = useSearch({ from: "/verify-email" });

	useEffect(() => {
		if (token) {
			verifyEmailMutation.mutate(
				{ token },
				{
					onSuccess: () => {
						queryClient.setQueryData(
							userKeys.userInformation(),
							(oldData: UserInformation) => {
								return {
									...oldData,
									has_verified_email: true,
								};
							},
						);
						queryClient.refetchQueries({
							queryKey: userKeys.userInformation(),
						});
					},
				},
			);
		}
	}, [token]);

	if (verifyEmailMutation.isSuccess) {
		return <EmailVerified />;
	}

	if (verifyEmailMutation.isError) {
		return <EmailVerificationFailed />;
	}

	return <EmailVerifying />;
}
